module.exports = __webpack_public_path__ + "media/images/icon/icons8-Add-5d0749fb80a06a436ad843d201c65c6f.png";